import { Helper } from '../Helper';
export class RawIteratorForEachFuncHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.rawIteratorForEachFuncBase({
            handleNext: () => {
                sb.emitSysCall(node, 'Neo.Iterator.Key');
                sb.emitOp(node, 'OVER');
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PACK');
            },
        }));
    }
}

//# sourceMappingURL=RawIteratorForEachFuncHelper.js.map
